import { objectWithRandomUniqueKey } from '../../../../../common/utils/randomUniqueKey';
import { z } from 'zod/v3';

const AlgorithmJoinItemBaseFormDataSchema = z.object({
  id: z.number(),
});

export const AlgorithmJoinItemFormDataSchema = z
  .union([
    AlgorithmJoinItemBaseFormDataSchema.extend({
      algorithmSourceId: z.number(),
      sourceDimension: z.string(),
      targetDimension: z.string(),
    }).transform((data) => ({
      _variant: 'DIMENSION_DIMENSION' as const,
      ...data,
    })),
    AlgorithmJoinItemBaseFormDataSchema.extend({
      algorithmSourceId: z.number(),
      sourceDimension: z.string(),
      targetValue: z.string(),
    }).transform((data) => ({
      _variant: 'DIMENSION_VALUE' as const,
      ...data,
    })),
    AlgorithmJoinItemBaseFormDataSchema.extend({
      sourceValue: z.string(),
      targetDimension: z.string(),
    }).transform((data) => ({
      _variant: 'VALUE_DIMENSION' as const,
      ...data,
    })),
    AlgorithmJoinItemBaseFormDataSchema.extend({
      algorithmMappingAlias: z.string(),
      targetDimension: z.string(),
    }).transform((data) => ({
      _variant: 'MAPPING_DIMENSION' as const,
      ...data,
    })),
    AlgorithmJoinItemBaseFormDataSchema.extend({
      algorithmMappingAlias: z.string(),
      targetValue: z.string(),
    }).transform((data) => ({
      _variant: 'MAPPING_VALUE' as const,
      ...data,
    })),
    AlgorithmJoinItemBaseFormDataSchema.extend({
      algorithmSourceId: z.number(),
      sourceDimension: z.string(),
      algorithmMappingAlias: z.string(),
    }).transform((data) => ({
      _variant: 'DIMENSION_MAPPING' as const,
      ...data,
    })),
    AlgorithmJoinItemBaseFormDataSchema.extend({
      sourceValue: z.string(),
      algorithmMappingAlias: z.string(),
    }).transform((data) => ({
      _variant: 'VALUE_MAPPING' as const,
      ...data,
    })),
  ])
  .transform(objectWithRandomUniqueKey);
